import { createContext } from "react";
import { LivePropsUpperBound, LiveSourceType } from ".";

type LiveContext = {
  tier: number; // "depth" of a live component t0 is the xb app, t1 is the page component etc...
  liveProps: LivePropsUpperBound; // force single layer string store to promote using Super Graph
  xbAppName: string;
  lcType?: LiveSourceType;
  remoteProvidedErrorFallback?: React.ReactNode | (() => React.ReactNode);
};

/**
 * An internal context we use to support different functions of LiveComponents.
 * E.g. This is how we enable "cascading" props
 *
 * DO NOT USE OUTSIDE OF XB PACKAGES
 */
export const LiveContext = createContext<LiveContext>({
  tier: 0,
  liveProps: {},
  xbAppName: "NoLiveContextProviderFound",
});
